import { getReadStaticActions, ReadStaticAction } from 'owa-surface-actions';

let readStaticActionsMap: { [id: string]: ReadStaticAction } = null;

export default function getReadStaticActionsMap() {
    if (!readStaticActionsMap) {
        initializeReadStaticActionsMap();
    }
    return readStaticActionsMap;
}

function initializeReadStaticActionsMap() {
    readStaticActionsMap = {};
    const readStaticActions = getReadStaticActions();
    readStaticActions.forEach(action => {
        readStaticActionsMap[action.key] = action;
    });
}
